import React, {useEffect} from 'react';
import './Interactivegames.css';
import trampoline from "../../../assets/img/imagefile/imagefile/Interactive Games.png"
import beetree from "../../../assets/img/imagefile/imagefile/beetree.jpg";
import gemslicer from "../../../assets/img/imagefile/imagefile/gemslicer1.jpg";
import airball from "../../../assets/img/imagefile/imagefile/airball1.jpg";
import minibowl from "../../../assets/img/imagefile/imagefile/minibowl.jpg";
import playground from '../../../assets/gem_products/1jump and touch.jpg';
import mariojump from '../../../assets/gem_products/Mario jump.jpg';
import interactiveGame from '../../../assets/gem_products/challenge.jpg';
import speedlight from '../../../assets/gem_products/speedy light.jpg';
import dodgeball from '../../../assets/gem_products/dodge ball.jpg';
import discodancer from '../../../assets/gem_products/disco dancer.jpg';
import wallthrow from '../../../assets/gem_products/wall throw game.jpg';
import hamster from '../../../assets/gem_products/hamster.jpg';
import ballblaster from '../../../assets/gem_products/ball blaster.jpg';
import { Link } from "react-router-dom";
import plusicon from '../../../assets/img/product_img/plusicon.png';
import Dashboard from '../../../components/Dashboard';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import Breadcrumb from '../../../Breadcrumb';
import { Helmet } from "react-helmet-async";
import WhatsappButton from '../../../components/WhatsappButton';

const Interactivegames = () => {
  let description = (<><h2 className="dashboard-content">Your gateway to the ultimate entertainment experience!Explore
    our cutting-edge products and immerse yourself in a world of
    innovation and excitement.
    </h2>
</>)
  return (
    <div>
      <Helmet>
              <meta name="playground equipment manufacturers" content="GEM is a leading trampoline brand offering the highest 
quality products. Trusted by playground equipment 
manufacturers for durability, safety, and fun." />


<meta name="playground equipment catalog" content="Discover GEM, the highest quality trampoline in our 
playground equipment catalog. Perfect for fun and safety, 
ideal for any playground setup" />


<meta name="playground equipment suppliers" content="Explore GEM, the highest quality trampoline, in our 
playground equipment catalog. Discover top-notch
 products for fun and safety in one place." />


<meta name="commercial indoor playground equipment" content="Discover GEM, the highest quality trampoline for ultimate 
fun and safety. Explore our premium commercial indoor
 playground equipment designed for all ages" />


<meta name="playgrounds" content="Experience the highest quality with GEM Trampolines!
 Perfect for intense Dodge Ball games, our durable and 
safe trampolines bring ultimate fun & excitement. " />


<meta name="indoor commercial playground" content="Discover GEM, the highest quality trampoline for ultimate 
fun and safety. Explore our playground equipment catalog
 for premium outdoor play solutions" />

<meta name="highest quality trampoline" content="Experience the highest quality GEM trampoline, perfect for
 indoor family entertainment centers. Safe, durable, and fun
—elevate your venue with the best in bounce" />


<meta name="indoor commercial playground" content="GEM offers the highest quality trampoline experience for all 
ages! Enjoy safe, fun, and exciting jumps at our premium 
indoor playground. Visit us today" />


<meta name="indoor playground" content="Discover GEM, the highest quality trampoline for
 playgrounds! Built for safety, durability, and endless fun, our 
trampolines elevate any play space. Shop now" />


<meta name="playground equipment catalog" content="Discover GEM, the highest quality trampoline for ultimate fun 
& safety. We also specialize in soft play installation for a 
complete indoor play experience!" />


<meta name="indoor commercial playground" content="Experience the ultimate fun at GEM, the highest quality 
trampoline park with soft play! Jump, bounce, and explore in a 
safe, exciting environment for all ages." />


<meta name="commercial indoor playground equipment" content="GEM offers the highest quality trampoline for ultimate fun & safety.
 Perfect for any kids playground, our durable trampolines ensure 
endless jumping excitement!" />

<meta name="playground equipment manufacturers" content="GEM, a leading playground equipment manufacturer, offers the
 highest quality trampolines designed for safety, durability, and fun. 
Perfect for parks & backyards" />



            </Helmet>
      <Header />
      <Dashboard  Breadcrumb={
    <div style={{ backgroundColor: '', marginTop: '13%',marginLeft:"2%", borderRadius: '5px',width:"100%" }}>
      <Breadcrumb />
    </div>
  } title={"Interactive Games"} imageUrl={trampoline} description={description}/>
     <div>
          {/* Whats App Icon */}
          <WhatsappButton
            altText="Chat with us on WhatsApp"
            iconSize={70}
          />
          <Link to="/getquotations" style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className="icon-container">
              <img
                src={plusicon}
                alt="playground equipment catalog"
                className="Producticon"
                style={{ cursor: "pointer" }}
              />
              <button className="quotation-button">Get Quotation</button>
            </div>
          </Link>
        </div>
      <div className="product-container">
          <div className='product-row'>
            <div className="product" >
              <Link to="/Interactivegames/MarioJump" style={{ textDecoration: 'none', color: 'inherit' }}>
                <img src={mariojump} alt="indoor commercial playground" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p>Mario Jump
                </p>
              </Link>
            </div>
            <div className="product" >
              <Link to="/Interactivegames/JumpnTouch" style={{ textDecoration: 'none', color: 'inherit' }}>

                <img src={playground} alt="commercial indoor playground equipment" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p> Jump’n Touch
                </p>
              </Link>
            </div>
            <div className="product" >
              <Link to="/Interactivegames/ChallengerTrampoline" style={{ textDecoration: 'none', color: 'inherit' }}>
                <img src={interactiveGame} alt="playground equipment manufacturers" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p>Challenge Trampoline
                </p>
              </Link>
            </div>
          </div>
          <div className='product-row'>
            <div className="product" >
              <Link to="/Interactivegames/SpeedyLight" style={{ textDecoration: 'none', color: 'inherit' }}>
                <img src={speedlight} alt="trampoline company" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p>Speedy Light
                </p>
              </Link>
            </div>
            <div className="product" >
              <Link to="/Interactivegames/DodgeBall" style={{ textDecoration: 'none', color: 'inherit' }}>

                <img src={dodgeball} alt="playground equipment company" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p>Dodge Ball
                </p>
              </Link>
            </div>
            <div className="product" >
              <Link to="/Interactivegames/DiscoDancer" style={{ textDecoration: 'none', color: 'inherit' }}>

                <img src={discodancer} alt="soft play installation" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p>Disco Dancer</p>
              </Link>
            </div>
            
          </div>

          <div className='product-row'>
            <div className="product" >
              <Link to="/Interactivegames/GEMSlicer" style={{ textDecoration: 'none', color: 'inherit' }}>

                <img src={gemslicer} alt="indoor commercial playground" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p>GEM Slicer
                </p>
              </Link>
            </div>
            <div className="product" >
              <Link to="/Interactivegames/WallThrowGame" style={{ textDecoration: 'none', color: 'inherit' }}>

                <img src={wallthrow} alt="kids playground" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p>Wall Throw Game
                </p>
              </Link>
            </div>
            <div className="product" >
              <Link to="/Interactivegames/BeeTree" style={{ textDecoration: 'none', color: 'inherit' }}>

                <img src={beetree} alt="indoor playground" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p>Bee Tree</p>
              </Link>
            </div>
            
            </div>
          
            <div className='product-row'>
            <div className="product" >
              <Link to="/Interactivegames/Hamster" style={{ textDecoration: 'none', color: 'inherit' }}>

                <img src={hamster} alt="playground equipment manufacturers" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p>Hamster
                </p>
              </Link>
            </div>
            <div className="product" >
              <Link to="/Interactivegames/AirBall" style={{ textDecoration: 'none', color: 'inherit' }}>

                <img src={airball} alt="playgrounds" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p>Air Ball
                </p>
              </Link>
            </div>
            <div className="product" >
              <Link to="/Interactivegames/BallBlaster" style={{ textDecoration: 'none', color: 'inherit' }}>

                <img src={ballblaster} alt="playground equipment manufacturers" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p>Ball Blaster</p>
              </Link>
            </div>
            
            </div>
          
            <div className='product-row'>
            <div className="product" >
              <Link to="/Interactivegames/MiniBowling" style={{ textDecoration: 'none', color: 'inherit' }}>

                <img src={minibowl} alt="indoor playground design" className="product-image"
                  style={{ cursor: 'pointer' }} />
                <p>Mini Bowling
                </p>
              </Link>
            </div>
            
            
            </div>


        </div>
      {/* Include Footer component */}
      <Footer />
    </div>
  );
};




export default Interactivegames;
